<template>
  <nav>
  <v-app-bar
    app
    dense
    height="42"
    color="#339966"
    class="small-app-bar"
    dark>
    <v-app-bar-nav-icon @click.stop="drawer=!drawer">
    </v-app-bar-nav-icon>
      <v-spacer/>
       <v-autocomplete
        style="zoom: 90%"
        v-model="model"
        :items="items"
        :loading="isLoading"
        :search-input.sync="search"
        clearable
        hide-details
        hide-selected
        hide-no-data
        item-text="name"
        item-value="symbol"
        label="Search for reports"
        filled
        outlined
        single-line
        flat
        solo-inverted
        prepend-inner-icon="mdi-archive-search-outline"
        append-icon="mdi-pause-box-outline"
        class="hidden-sm-and-down"
        color="#339966"
        return-object
        compact
        dense
        @change="loadReport"
        :menu-props="{ contentClass: 'autocomplete-menu-small' }"/>
      <v-spacer/>
      <v-menu
        v-if="keycloakIsActive">
        <template v-slot:activator="{on, attrs}">
         <v-btn
          icon
          class="mr-3"
          v-bind="attrs"
          v-on="on">
          <v-icon>mdi-apps</v-icon>
        </v-btn>
        </template>
        <v-card class="mx-auto ml-20" max-width="380" tile>
        <v-list dense >
          <v-subheader>Other Applications</v-subheader>
          <v-list-item-group
            color="#339966">
            <v-list-item
              v-for="(item, i) in menuApps"
              :key="i"
              @click="appClick(item.action)">
                <v-list-item-icon >
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title style=" font-size: 0.82em;" v-text="item.text"></v-list-item-title>
                </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
        </v-card>
      </v-menu>
      <v-avatar v-if="user" @click="aiAssistant = !aiAssistant">
        <img
          style="height: 20px; cursor: pointer;"
          src="../assets/artificial-intelligence.svg"
          alt="AI"
        >
      </v-avatar>
      <v-badge
        class="ml-2 mr-6"
        color="#f8b500"
        dot
        left
        :value="visibility">
        <v-icon
            @click="pageRoute('/userNotifications')"
            color="white lighten-1"
            size="24">
            mdi-bell-badge-outline
          </v-icon>
      </v-badge>
      <v-avatar
        class="mr-2 red darken-2 lighten-1"
        size="24">
        <v-icon @click="pageRoute('/userViewedReports', 1)" size="16" dark>mdi-shaker</v-icon>
      </v-avatar>
      <v-menu>
        <template v-slot:activator="{on, attrs}">
         <v-btn
          icon
          v-bind="attrs"
          v-on="on">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
        </template>
        <v-card class="mx-auto" max-width="300" tile>
        <v-list dense shaped v-if="isAdminLoaded" >
          <v-subheader>Menu</v-subheader>
          <v-list-item-group
            color="#339966">
            <v-list-item
              v-for="(item, i) in menuItems"
              :key="i"
              @click="itemClick(item.action)">
                <v-list-item-icon >
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title style=" font-size: 0.82em;" v-text="item.text"></v-list-item-title>
                </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
        </v-card>
      </v-menu>
  </v-app-bar>
  <v-navigation-drawer
    v-model="drawer"
    class="white nav-height"
    :width="264"
    style=" height: 100%;"
    app>
    <v-app-bar
      flat
      dense
      height="42"
      color="#39ac73">
    <v-spacer/>
    <v-img
        class="pa-0 ma-0"
        alt="EGPAF logo"
        contain
        src="../assets/coat-of-arms.png"
        transition="scale-transition"
        height="32px"
        width="0px"
        style="border-radius: 50%; cursor: pointer;"/>
     <span class="white--text large font-weight-medium m-0 p-0 caption" style="cursor: pointer;">MOH</span>
     <v-spacer/>
    </v-app-bar>
     <v-list shaped dense>
        <v-subheader class="pl-5">Main Menu</v-subheader>
        <v-list-item-group
            color="#339966">
        <template v-for="item in links">
          <v-row
            v-if="item.heading"
            :key="item.heading"
            align="center">
            <v-col cols="6">
              <v-subheader class="black-text" v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-col>
            <v-col
              cols="6"
              class="text-center">
              <a
                href="#!"
                class="body-2 black--text"
              >EDIT</a>
            </v-col>
          </v-row>
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon="">
            <template v-slot:activator>
              <v-list-item-content >
                <v-list-item-title class="caption black--text font-weight-medium">
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
              <v-icon small>mdi-checkbox-multiple-blank-circle</v-icon>
            </template>
            <v-list-item
              v-for="(child, i) in item.children"
              :key="i"
              link
               @click="pageRoute(child.route)">
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="black--text" style=" font-size: 0.82em;">
                  {{ child.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item
            v-else-if="item.text==='Register Users' && isAdmin"
            :key="item.text"
            :to="item.route"
            active-class="highlighted"
            @click.stop="pageRoute(item.route)">
          <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="text--black font-weight-medium" style=" font-size: 0.82em;">
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
           <v-list-item
            v-else-if="item.text==='Activate Users' && isAdmin"
            :key="item.text"
            :to="item.route"
            active-class="highlighted"
            @click.stop="pageRoute(item.route)">
          <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="text--black font-weight-medium" style=" font-size: 0.82em;">
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action v-if="activationNotification == true">
              <v-icon small color="red">mdi-bell-ring</v-icon>
            </v-list-item-action>
          </v-list-item>
           <v-list-item
            v-else-if="item.text!=='Register Users' && item.text!=='Activate Users'"
            :key="item.text"
            :to="item.route"
            active-class="highlighted"
            @click.stop="pageRoute(item.route)">
          <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="text--black font-weight-medium" style=" font-size: 0.82em;">
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        </v-list-item-group>
      </v-list>
      <v-list shaped dense>
        <v-subheader class="pl-5">Extras</v-subheader>
           <v-list-item-group
             color="#339966">
            <v-list-item @click="itemClick (10)">
              <v-list-item-icon>
                <v-icon>mdi-power-settings</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title style=" font-size: 0.82em;">Sign Out</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
      </v-list>
      <v-list>
         <v-list-item style="position: absolute; bottom: 0;" class="mt-2 mb-2">
              <img
                  class="pr-1 mt-1"
                  alt="EGPAF logo"
                  contain
                  src="../assets/new-pepfar.png"
                  transition="scale-transition"
                  style="width: 20%;"/>
              <img
                  class="pl-2 pr-1 ma-0"
                  alt="EGPAF logo"
                  src="../assets/egpaf-logo.jpg"
                  transition="scale-transition"
                  height="36px"
                  width="70%"/>
          </v-list-item>
      </v-list>
  </v-navigation-drawer>
  <template>
  <v-row justify="center">
    <v-snackbar
      id="snack"
      color="#339966"
      v-model="snackbar"
      right
      style="position: fixed; "
      class="mb-6 ma-19">
      <v-layout class="pa-4">
        <span name="app" dark style=" font-size: 0.88em;"><v-icon color="white"> {{snackbarError.icon}}</v-icon> {{snackbarError.label}}  </span>
        <v-spacer/>
      </v-layout>
   </v-snackbar>
  </v-row>
</template>
<template>
  <v-row justify="center">
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="searchDialog"
      persistent
      max-width="315">
      <v-card tile>
        <v-progress-linear
          indeterminate
          color="green"
          striped
          class="mb-0"
        ></v-progress-linear>
        <v-card-title class="subtitle-2">
          Loading the {{reportName}} Report
        </v-card-title>
        <v-card-text pb-4><v-icon color="#f8b500">mdi-server</v-icon> loading please wait...</v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<template>
    <v-row justify="center">
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="tokenDialog"
      persistent
      scrollable
      max-width="300">
      <v-card tile>
        <v-card-title class="subtitle-2">
          Access Authorization
        </v-card-title>
         <v-card-text class="pb-2 pt-1"><v-icon color="red">mdi-door-closed</v-icon> Your access token has expired.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="keycloakIsActive"
            dark
            text
            style="font-size: 0.88em;"
            color="green darken-3"
            @click="reLogin()">
            Stay Signed In
          </v-btn>
          <v-btn
            dark
            text
            style="font-size: 0.88em;"
            color="green darken-3"
            @click="logout">
            SignOut
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

 <!-- the chat bot -->
    <template>
        <v-dialog
          v-model="aiAssistant"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-card id="chat">
            <v-toolbar
              dark
              dense
              color="#39ac73"
              style="position: sticky; top: 0; z-index: 1;"
            >
            <v-btn
              icon
              dark
              @click="aiAssistant = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <span class="white--text large font-weight-bold caption">Chat</span>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                v-if="chat.length > 0 && !isLoading" @click="deleteChat()"
                dark
                text
                small
              >
                <span class="white--text font-weight-bold text-none caption" style="font-size: 0.6em">Clear Chat</span>
              </v-btn>
               <v-btn
                dark
                text
                @click="aiAssistant = false"
                small
              >
                <span class="white--text font-weight-bold text-none caption" style="font-size: 0.6em">Close</span>
              </v-btn>
            </v-toolbar-items>
            </v-toolbar>
              <v-list
                three-line
                subheader
                ref="list" 
                style="
                  height: calc(100vh - 105px);
                  overflow-y: auto;
                  padding-bottom: 120px;
                "
              >
                <!-- no messages -->
                <div v-if="chat.length === 0" class="center-container" style=" background-color: blackx; height: 90vh; ">
                  <div class="">
                    <div justify="center" >
                      <h1 justify="center" align="center">Hi</h1>
                      <p justify="center" align="center">Ask me anything about the Malawi Analytics Platform.</p>
                      <!-- <p justify="center" align="center">Ask me anything about the Qualitative and Quantitative DQA.</p> -->
                    </div>
                  <v-container>
                    <v-row
                      justify="center"
                      align="center"
                      gap="24" 
                    >
                      <v-chip  v-for="(data, i) in chatbotTopics" :key="i"
                        class="ma-2 px-4"
                      >
                        <v-icon left :color="data.color">
                          {{ data.icon }}
                        </v-icon>
                        {{ data.title }}
                      </v-chip>
                    </v-row>
                  </v-container>
                  </div>
                </div>
                <!-- messages are there -->
                <div v-else v-for="(data, i) in chat" :key="i" :class="['chat-container', data.role === 'user' ? 'user mx-4' : 'other ml-4 mr-10 ']">
                    <p v-if="data.role==='user' || (i !== chat.length - 1 && data.role==='user')" class="chat-bubble p-2" style=" background-color: #339966;" >{{ data.content }}</p>
                     <vue-typed-js v-else
                      :strings="[data.content]"
                      :typeSpeed="1"
                      :backSpeed="40"
                      :loop="false"
                      :showCursor="false" 
                      @onComplete="onCompleteTyping" 
                    >
                      <span class="typing preserve-breaks ml-4 mr-10"></span>
                    </vue-typed-js>
                  </div>
                  <!-- the space -->
                  <div v-if="!isLoading" style="padding-top: 100px;"></div>
                   <div class="mx-6" v-if="isLoading" style="background-color: #339966; padding: 4px; width: 40px; height: 40px; border-radius: 100%; ">
                      <v-progress-circular 
                        indeterminate
                        color="white"
                        width="2"
                      >
                        <v-avatar>
                          <img
                            class="pa-1"
                            style="height: 26px; width: 26px; cursor: pointer;"
                            src="../assets/artificial-intelligence.png"
                            alt="AI"
                          >
                        </v-avatar>
                      </v-progress-circular>
                    </div>
                <!-- chat message box -->
                <div style=" position: fixed; background-color: #339966; bottom: 0; left: 50%; transform: translate(-50%); margin-bottom: 30px; border-radius: 72px; padding: 16px; display: flex; align-items: center; justify-content: center;">
                  <!-- <v-icon v-if="chat.length > 0 && !isLoading" @click="deleteChat()" color="white">mdi-delete-outline</v-icon> -->
                  <!-- the chat box -->
                  <input @keyup.enter='sendMessage()' v-model="userMessage" placeholder="Ask anything about MAP or indicators..." style=" width: 600px; margin: 4px; outline: none; color: white; box-shadow: none;" class="white-placeholder" @focus="this.style.outline='none'; this.style.boxShadow='none';">
                  <!-- <input @keyup.enter='sendMessage()' v-model="userMessage" placeholder="Ask anything about the qualitative and quantitative DQA..." style=" width: 600px; margin: 4px; outline: none; color: white; box-shadow: none;" class="white-placeholder" @focus="this.style.outline='none'; this.style.boxShadow='none';"> -->
                  <!-- the send button -->
                  <v-progress-circular v-if="isLoading"
                    indeterminate
                    color="white"
                    width="3"
                    >
                    <!-- <v-avatar>
                      <img
                        class="pa-1"
                        style="height: 24px; cursor: pointer;"
                        src="../assets/ai-assistant-2.svg"
                        alt="AI"
                      >
                    </v-avatar> -->
                    <v-icon size="22" class="p-1" color="white">mdi-airplane-takeoff</v-icon>
                  </v-progress-circular>
                  <v-icon @click="sendMessage()" v-else size="36" color="white">mdi-send-circle</v-icon>
                </div>
              </v-list>
            </v-card>
          </v-dialog>
      </template>
  </nav>
</template>

<script>
import { isMobile } from 'mobile-device-detect'

export default {
  name: 'App',
  props: {
    source: String
  },
  components: {
    
  },
  data: () => {
    return {
      list: [
        '2vh046nv0b6',
        "1nu84rhs778",
        "3bclfn7cy7",
        "4llpdg83x88",
        "5yqjuq1issw",
        "bswbtdmyko9",
        "etjtbfnj4ab",
        "gc8ebn6gapg",
        "hcji7kn1sq",
        "heyxnhhugt",
        "i1290ek1ari",
        "i66obl89wdo",
        "o0an281es5",
        "sbhcktl2qk",
        "x0g3auzxn1s",
        "yz7gq7rdmk"
      ],
      user: null,
      userMessage: '',
      storedInput: '',
      chat: [],
      chatbotTopics: [
        { title: "Ask about MAP.", icon: 'mdi-state-machine', color: '#339966' },
        { title: "Search for a visual by describing it.", icon: 'mdi-chart-box-outline', color: 'red' },
        { title: "Ask about PEPFAR indicators.", icon: 'mdi-medication-outline', color: '#339966' },
      ],
      aiAssistant: false,
      keycloakIsActive: false,
      ownerName: '',
      activationNotification: false,
      reportName: '',
      tokenDialog: false,
      searchDialog: false,
      snackbar: false,
      dialog: false,
      isAdmin: false,
      isAdminLoaded: false,
      visibility: false,
      drawer: !isMobile,
      links: [
        { icon: 'mdi-home-import-outline', text: 'Home', route: '/userHome' },
        { icon: 'mdi-card-bulleted-settings-outline', text: 'My History', route: '/UserHistory' },
        { icon: 'mdi-remote-desktop', text: 'Most Viewed Reports', route: '/userViewedReports' },
        { icon: 'mdi-archive-eye-outline', text: 'See All Reports', route: '/userSeeReports' },
        { icon: 'mdi-shimmer', text: 'Latest Reports', route: '/userLatestReports' },
        { icon: 'mdi-file-cabinet', text: 'Data lake', route: '/dataLake' },
        { icon: 'mdi-account-multiple-plus-outline', text: 'Register Users', route: '/userAddUser' },
        { icon: 'mdi-seal', text: 'Activate Users', route: '/userActivateUser' },
        { icon: 'mdi-file-document-multiple-outline', text: 'Request Report Access', route: '/allAvailableReports' }
      ],
      menuItems: [
        // { text: 'Manage User Permissions', icon: 'mdi-cog-clockwise' },
        // { text: 'Data Lake', icon: 'mdi-file-cabinet' },
        { text: 'Edit Profile', icon: 'mdi-account-edit-outline', action: 0 },
        { text: 'Add a Report', icon: 'mdi-chart-box-plus-outline', action: 1 },
        { text: 'Edit a Report', icon: 'mdi-circle-edit-outline', action: 2 },
        { text: 'Delete a Report', icon: 'mdi-delete-empty-outline', action: 3 },
        { text: 'See My Group\'s Reports', icon: 'mdi-select-group', action: 4 },
        { text: 'Manage User Report Permissions', icon: 'mdi-archive-lock-outline', action: 5 },
        { text: 'Manage Group Permissions', icon: 'mdi-account-group-outline', action: 6 },
        { text: 'Report Updates', icon: 'mdi-chart-box-outline', action: 7 },
        { text: 'Start a Slideshow', icon: 'mdi-television-pause', action: 8 },
        { text: 'Deactivated Users', icon: 'mdi-account-multiple-remove-outline', action: 9 },
        { text: 'Sign Out', icon: 'mdi-power-settings', action: 10 }
      ],
      menuApps: [
        { text: 'Integrated Data Access and Request Platform (iDARP)  ', icon: 'mdi-square-rounded-badge-outline', action: 0 },
      ],
      isLoading: false,
      items: [],
      model: null,
      search: null,
      snackbarError: { icon: 'mdi-server-security', label: 'Cannot connect to the server, network error!' },
      conversationId: null
    }
  },
  methods: {
    onCompleteTyping () {
      this.$nextTick(() => {
        const list = this.$refs.list.$el || this.$refs.list;
        list.scrollTo({
          top: list.scrollHeight,
          behavior: "smooth"
        });
        // console.log('called')
      })
    },
    deleteChat () {
      this.chat = []
    },
    sendMessage () {
      if (this.userMessage.trim() !== '') {
        // scroll
        this.onCompleteTyping()

        // start the API call
        this.storedInput = this.userMessage
        this.isLoading = true
        this.userMessage = ''
        const data = {
          role: 'user',
          content: this.storedInput
        }
        this.chat.push(data)

        window.axios.post('/chat/chat', { prompt: this.storedInput, conversationId: this.conversationId })
        .then(async (response) => {
          const genieSays = response.data
          const attachments = genieSays.attachments
          this.conversationId = genieSays.conversation_id

          var message = ""

          // get the size of the attchments
          const textMessage = attachments?.find(attachment => attachment.text)
          message = textMessage.text.content.replaceAll("**", "  ");
        
          const data = {
            role: 'system',
            content: message
          }
          this.chat.push(data)
          this.isLoading = false

        })
        // eslint-disable-next-line handle-callback-err
        .catch((err) => {
          // remove the last chat
          const size = this.chat.length
          this.chat.splice((size - 1), 1)

          console.log(err)
          this.isLoading = false
          this.userMessage = this.storedInput
        })
      }
    },
    // triggers the user to login again
    reLogin () {
      // call the keycloak authentication url
      // window.location.href  = `https://ihss.hismalawi.org/map-back-end/user/keycloakLogin`
      window.location.href  = `http://localhost:7400/user/keycloakLogin`
    },
    // handle the app clicks
    appClick (i) {
      const keycloak = JSON.parse(localStorage.getItem('keycloak'))
      const token = keycloak.token
      const refreshToken = keycloak.refreshToken
      // const url = `https://test.idarp.mw/verify-tokens?access_token=${token}&refresh_token=${refreshToken}`
      // console.log('called', keycloak, i, url)

      switch (i) {
        case 0:
          // go to idarp
          window.open(`https://test.idarp.mw/verify-tokens?access_token=${token}&refresh_token=${refreshToken}`, '_blank')
          break
      }
    },
    logout () {
      const id = localStorage.getItem('kwkk')
      var keycloak = localStorage.getItem('keycloak')
      var refreshToken = ''
      if (keycloak !== undefined && keycloak !== null && JSON.parse(keycloak).refreshToken !== null) {
        refreshToken = JSON.parse(keycloak).refreshToken
      }
      window.axios.post('/signin/signout', { userId: id, refreshToken: refreshToken})
        .then(async () => {
          this.$router.push('/')
        })
        // eslint-disable-next-line handle-callback-err
        .catch(() => {
          this.$router.push('/')
        })
    },
    adminRequest () {
      var id = localStorage.getItem('kwkk')
      window.axios.post('/adminRequest/insert', { userId: id })
        .then((response) => {
          // console.log(response.data.affectedRows)
          if (response.data.affectedRows === 0) {
            this.snackbar = true
            this.snackbarError = { icon: 'mdi-server-security', label: response.data.message }
          } else {
            this.snackbar = true
            this.snackbarError = { icon: 'mdi-server-security', label: 'Successfully sent the admin status request !' }
          }
          this.dialog = false
        })
        // eslint-disable-next-line handle-callback-err
        .catch(() => {
          this.dialog = false
          this.snackbarError = { icon: 'mdi-server-security', label: 'Cannot connect to the server, network error !' }
          this.snackbar = true
        })
    },
    itemClick (i) {
      const currentRoute = this.$router.currentRoute.path
      switch (i) {
        // case 0:
        //   this.$router.push('/userPermissions')
        //   break
        // case 0:
        //   this.$router.push('/dataLake')
        //   break
        case 0:
          this.selectedItem = 1
          if (currentRoute !== '/userEditProfile') {
            this.$router.push('/userEditProfile')
          }
          break
        case 1:
          this.selectedItem = 1
          if (currentRoute !== '/userAddReport') {
            this.$router.push('/userAddReport')
          }
          break
        case 2:
          this.selectedItem = 1
          if (currentRoute !== '/userEditReport') {
            this.$router.push('/userEditReport')
          }
          break
        case 3:
          this.selectedItem = 1
          if (currentRoute !== '/userDeleteReport') {
            this.$router.push('/userDeleteReport')
          }
          break
        case 4:
          this.selectedItem = 1
          if (currentRoute !== '/userAdminSeeReport') {
            this.$router.push('/userAdminSeeReport')
          }
          break
        case 5:
          this.selectedItem = 1
          if (currentRoute !== '/userAdminManageUserPermissions') {
            this.$router.push('/userAdminManageUserPermissions')
          }
          break
        case 6:
          this.selectedItem = 1
          if (currentRoute !== '/userManagePermissions') {
            this.$router.push('/userManagePermissions')
          }
          break
        case 7:
          this.selectedItem = 1
          if (currentRoute !== '/userReportUpdates') {
            this.$router.push('/userReportUpdates')
          }
          break
        case 8:
          this.selectedItem = 1
          if (currentRoute !== '/slideshow') {
            this.$router.push('/slideshow')
          }
          break
        case 9:
          this.selectedItem = 1
          if (currentRoute !== '/userDeactivatedUsers') {
            this.$router.push('/userDeactivatedUsers')
          }
          break
        case 10:
          this.logout()
          break
        default:
          this.selectedItem = 1
          if (currentRoute !== '/userHome') {
            this.$router.push('/userHome')
          }
      }
    },
    pageRoute (route) {
      // finding the position of the route
      for (var i = 0; i < this.links.length; i++) {
        if (route === this.links[i].route) {
          localStorage.setItem('sl', i)
          break
        }
      }
      this.$router.push(route).catch(() => {
        window.location.reload()
      })
    },
    loadReport (item) {
      this.reportName = item.type
      var userId = localStorage.getItem('kwkk')
      var reportId = item.id
      window.axios.post('/viewership/insert', { userId: userId, reportId: reportId })
        .then((response) => {
          const viewershipId = response.data.insertId
          localStorage.setItem('viewershipId', viewershipId)
          if (item.type === 'Power Bi') {
            this.searchDialog = true
            const reportId = item.report_id
            const datasetId = item.dataset_id
            const embedUrl = item.embed_url
            window.axios.post('/viewership/getEmbedToken', { reportId: reportId, datasetId: datasetId })
              .then(async (response) => {
                const token = response.data.token
                this.searchDialog = false
                const passphrase = process.env.VUE_APP_PASSPHRASE
                const encryptedToken = this.CryptoJS.AES.encrypt(token, passphrase).toString()
                const encryptedReportId = this.CryptoJS.AES.encrypt(reportId, passphrase).toString()
                const encryptedEmbedUrl = this.CryptoJS.AES.encrypt(embedUrl, passphrase).toString()
                const encryptedName = this.CryptoJS.AES.encrypt(item.name, passphrase).toString()
                const encryptedDatasetId = this.CryptoJS.AES.encrypt(datasetId, passphrase).toString()
                localStorage.setItem('datasetId', encryptedDatasetId)
                localStorage.setItem('name', encryptedName)
                localStorage.setItem('tken', encryptedToken)
                localStorage.setItem('reportId', encryptedReportId)
                localStorage.setItem('embUrl', encryptedEmbedUrl)
                this.$router.push('userPowerBiVisual')
                window.location.reload()
              })
              // eslint-disable-next-line handle-callback-err
              .catch(() => {
                this.snackbar = true
                this.searchDialog = false
              })
          } else if (item.type === 'Web Embed' || item.type === 'Dash') {
            this.searchDialog = true
            this.dialog = false
            const embedUrl = item.embed_url
            const passphrase = process.env.VUE_APP_PASSPHRASE
            const encryptedEmbedUrl = this.CryptoJS.AES.encrypt(embedUrl, passphrase).toString()
            const encryptedName = this.CryptoJS.AES.encrypt(item.name, passphrase).toString()
            localStorage.setItem('name', encryptedName)
            localStorage.setItem('embUrl', encryptedEmbedUrl)
            this.$router.push('userSeeWebMap')
          } else {
            // this.$router.push('userJavaScriptVisual')
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(() => {
        })
    }
  },
  mounted: function () {
    try {
      // check keycloak crdentials
      const keycloak = localStorage.getItem('keycloak')

      if (keycloak !== undefined && keycloak !== null) {
        this.keycloakIsActive = true
      }

      var passphrase = process.env.VUE_APP_PASSPHRASE
      var accessToken = localStorage.getItem('token')
      var decryptedAccessToken = this.CryptoJS.AES.decrypt(accessToken, passphrase).toString(this.CryptoJS.enc.Utf8)
      window.axios.defaults.headers.common.Authorization = `Bearer ${decryptedAccessToken}`

      var id = localStorage.getItem('kwkk')
      this.user = this.list.some((data) => data == id)
      if (id === '' || id === null) {
        this.$router.push('/')
      }
      // finding the user admin
      window.axios.post('/userAdmin/findUserAdmin', { userId: id })
        .then((response) => {
          if (response.data.length === 1) {
            this.isAdmin = true
          } else {
            // remove the items from the the sub menu
            this.menuItems.splice(1, 7)
          }
          this.isAdminLoaded = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch(() => {
        })
      window.axios.post('/user/find', { id: id })
        .then((response) => {
          if (response.data.length === 0) {
            this.$router.push('/')
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(() => {
        })

      window.axios.get('/user/findCount', {
        headers: {
          'Authorization': `Bearer ${decryptedAccessToken}`
        }
      })
        .then(() => {
          // var count = response.data[0].count
          // if (count === -1) {
          //   const message = response.data[0].message
          //   if (message === 'jwt malformed') {
          //     this.$router.push('/')
          //   } else {
          //   }
          // }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((err) => {
          if (err.response.data === 'empty jwt token') {
            this.$router.push('/')
          } else if (err.response.data === 'jwt malformed' || err.response.data === 'keycloak expired') {
            // show the dialog that the access token has expired
            this.tokenDialog = true
          }
        })
      window.axios.post('/seen/findAllUnseen', { userId: id })
        .then((response) => {
          if (response.data.length === 0) {
            // removing the visibility if there are no unseen messages
            this.visibility = false
          } else {
            this.visibility = true
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(() => {
        })
      const userTypeId = localStorage.getItem('utp')
      const userId = localStorage.getItem('kwkk')
      window.axios.post('/user/findByUserTypeDeactivated', { userTypeId: userTypeId, userId: userId })
        .then((response) => {
          const length = response.data.length
          if (length > 0) {
            this.activationNotification = true
          } else {
            this.activationNotification = false
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(() => {
        })
        const perform = localStorage.getItem('perform')
        if (perform !== 'null' && perform !== null) {
          localStorage.removeItem('perform')
          // get the report & check if teh user is allowd to access it
          window.axios.post('/report/findRedirection', { userTypeId: userTypeId, userId: userId, id: perform })
            .then((response) => {
              localStorage.removeItem('perform')
              const data = response.data
              const size = data.length

              if (size > 0) {
                const reportData = data[0]
                // load the report
                // console.log(reportData)
                this.loadReport(reportData)
              }
            })
            // eslint-disable-next-line handle-callback-err
            .catch(() => {
              localStorage.removeItem('perform')
            })
        }
    } catch (err) {
      if (err.response.data === 'empty jwt token') {
        this.$router.push('/')
      } else if (err.response.data === 'jwt malformed' || err.response.data === 'keycloak expired') {
        // show the dialog that the access token has expired
        this.tokenDialog = true
      }
    }
  },
  watch: {
    aiAssistant (val) {
      if (val) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    },
    model (val) {
      if (val != null) this.tab = 0
      else this.tab = null
    },
    search (val) {
      // Items have already been loaded
      // if (this.items.length > 0) return

      this.isLoading = true
      const userGroupId = localStorage.getItem('utp')
      const userId = localStorage.getItem('kwkk')
      var url = '/report/searchByUserGroupIdAll' + '?searchText=' + val + '&userTypeId=' + userGroupId + '&userId=' + userId
      window.axios.get(url)
        .then((response) => {
          this.items = response.data
          this.isLoading = false
        })
        // eslint-disable-next-line handle-callback-err
        .catch(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
<style scoped>

.v-text-field >>> input {
  font-size: 0.74em;
  max-height: 3px;
  min-height: 36px;
}

.v-text-field >>> label {
  font-size: 0.74em;
}

.white-placeholder::placeholder {
    color: white;
  }

  .center-container {
    display: flex;
    justify-content: center; /* horizontal center */
    align-items: center;     /* vertical center */
    height: 100vh;           /* full viewport height */
  }

.chat-container {
  display: flex;
  margin: 1rem 0;
}

/* user messages align to right */
.chat-container.user {
  justify-content: flex-end;
}

/* other messages align to left (default) */
.chat-container.other {
  justify-content: flex-start;
}

.chat-bubble {
  padding: 0.5rem 1rem;
  border-radius: 0.6rem;
  max-width: 95%;
  word-wrap: break-word;
}

/* styling for user vs other */
.chat-container.user .chat-bubble {
  background-color: #44ac78;
  color: white;
}

.chat-container.other .chat-bubble {
  /* background-color: #e5e7eb; */
  color: black;
}

.preserve-breaks {
  white-space: pre-line;
}
</style>
